import { styled } from "styled-components";
const ModalFooter = styled("div")(({ theme }) => ({
  borderTop: `1px solid ${theme.borderColor}`,
  marginTop: "auto",
  padding: "8px 16px"
}));
export {
  ModalFooter
};
